export const ENCRYPTION_BYTES_BLOCK_LENGTH = 16;

export const ENCRYPTION_BITS_BLOCK_LENGTH = 128;

export const DEFAULT_INITIALIZATION_VECTOR = [0];

export const ALPHANUMERIC_LENGTH = 36;
